import styled from 'styled-components';

interface ItemProps {
  readonly size?: string;
}

export const BadgeImage = styled.img<ItemProps>`
  border: 1px solid var(--LightGray);
  border-radius: 50%;
  display: block;
  max-height: ${props => (props.size ? props.size : '140px')};
  min-height: ${props => (props.size ? props.size : '140px')};
  max-width: ${props => (props.size ? props.size : '140px')};
  min-width: ${props => (props.size ? props.size : '140px')};
  object-fit: cover;
`;

export const BadgeHidden = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
  justify-content: center;
  position: absolute;
  border-radius: 50%;
  align-items: center;
  display: none;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
`;

export const BadgeImageContainer = styled.div`
  border-radius: 50%;
  position: relative;
  height: 100%;

  &:hover ${BadgeHidden} {
    display: flex;
  }
`;

export const BadgeImageDelete = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  align-items: center;
  cursor: pointer;
  padding: 14px;
  display: flex;
`;

export const BadgeImageDeleteText = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #5d6c76;
  margin-left: 5px;
`;
